import * as ko from 'knockout';
import { Guid } from 'Core/Common/Guid';
import { Event } from 'Core/Common/Event';
import { EVENTS } from 'Core/Constant';

import { PortletsCollection } from 'Core/Portlets/Models/Design/Explorer/PortletsCollection';
import { PortletsExplorer } from 'Core/Portlets/Models/Design/Explorer/PortletsExplorer';
import { IPosition } from 'Core/Portlets/Models/Common/Interfaces/IPosition';
import { EntityPortlet } from 'Core/Portlets/Models/Design/Explorer/EntityPortlet';
import { PortletManager } from 'Core/Portlets/Managers/Runtime/PortletManager';
import { PortletStates } from 'Core/Portlets/Enums/PortletStates';
import { GuidToPortletInfoMap } from 'Core/Portlets/Utils/GuidToPortletInfoMap';
import { IPortletInfo } from 'Core/Portlets/Models/Common/Interfaces/IPortletInfo';
import { LABELS } from 'Core/Components/Translation/Locales';

export interface IDraggable {
    Guid: Guid;
    PrevPosition: IPosition;
    NewPosition: IPosition;
}

export class PortletDesignManager extends Event {
    private _portletsCollection: PortletsCollection;
    private _portletExplorer: KnockoutObservable<PortletsExplorer>;
    private _draggedFromExplorer: boolean;

    private _portletExplorereLoaded: boolean;
    private _draggablePortlets: Array<JQuery>;
    private _attachedPortlets: JQuery;
    private _labels = LABELS;

    constructor(portletsCollection: PortletsCollection) {
        super();

        portletsCollection.Entities.map((entity) =>
            entity.Portlets.forEach((portlet) => (portlet.Guid = Guid.NewGuid()))
        );

        this._portletsCollection = portletsCollection;
        this._portletExplorer = ko.observable(new PortletsExplorer(portletsCollection));
        this._draggedFromExplorer = false;

        this._draggablePortlets = [];

        this.BindEvents();
    }

    DestroyDragAndDrop() {
        this._draggablePortlets.forEach((draggable: JQuery) => draggable.sortable('destroy'));
    }

    InitDesignMode() {
        let $explorer = $('.portlet-explorer');
        let $exploredPortlets = $explorer.find('.portlet-draggable');
        let $attachedPortlets = $('.portlet-attached');

        this._draggablePortlets = new Array<JQuery>($exploredPortlets, $attachedPortlets);
        this._attachedPortlets = $attachedPortlets;

        var self = this;
        let exploredPortletPlaceholderClass = 'max-w-full border-yellow-500';
        let attachedPortletPlaceholderClass = '!m-0 min-w-full border-green-500';

        $exploredPortlets
            .sortable({
                connectWith: $attachedPortlets,
                placeholder: 'portlet-sortable-placeholder',
                forcePlaceholderSize: true,
                appendTo: 'body',
                zIndex: 100000,

                over(event, ui) {
                    ui.placeholder
                        .removeClass(`${attachedPortletPlaceholderClass}`)
                        .addClass(
                            `min-h-[34px] extra-placeholder-class ${exploredPortletPlaceholderClass}`
                        )
                        .html(
                            `<div class="placeholder-inner flex h-full w-full items-center justify-center"><a tabindex="-1" href="#" class="text-sm sps-btn sps-btn-outline btn-color-static-refresh w-full"><i class="fa fa-refresh"></i>${self._labels.CANCEL}</a></div>`
                        );
                },

                helper(event, portlet: JQueryUI.Sortable) {
                    this.copyHelper = portlet.clone().insertAfter(portlet);

                    $(this).data('copied', true);

                    return portlet.clone();
                },
                start(event, ui) {
                    self._draggedFromExplorer = true;

                    ui.helper.css({ position: 'fixed' });
                    ui.helper.css({
                        width: ui.item.outerWidth(),
                        height: ui.item.outerHeight(),
                    });

                    ui.placeholder.addClass(
                        `min-h-[34px] extra-placeholder-class ${exploredPortletPlaceholderClass}`
                    );
                },
                beforeStop(event, portlet) {
                    let copied = $(this).data('copied');
                    let droppedIntoExplorer = portlet.item.closest('.portlet-explorer').length > 0;

                    if (copied && droppedIntoExplorer) {
                        this.copyHelper.remove();
                        this.copyHelper = null;
                    }
                },
                stop() {
                    let copied = $(this).data('copied');

                    if (!copied) {
                        this.copyHelper.remove();
                    }

                    this.copyHelper = null;
                },
            })
            .disableSelection();

        $attachedPortlets
            .sortable({
                connectWith: $attachedPortlets,
                handle: '.portlet-title',
                placeholder: 'portlet-sortable-placeholder',
                opacity: 0.8,
                revert: 250,
                forcePlaceholderSize: true,
                tolerance: 'pointer',
                cancel: '.portlet-fullscreen',

                appendTo: 'body',
                helper: 'clone',

                over(event, ui) {
                    ui.placeholder
                        .removeClass(`${exploredPortletPlaceholderClass}`)
                        .addClass(
                            `min-h-[34px] extra-placeholder-class ${attachedPortletPlaceholderClass}`
                        )
                        .html(
                            `<div class="placeholder-inner flex h-full w-full items-center justify-center"><a tabindex="-1" href="#" class="text-sm sps-btn sps-btn-outline btn-color-static-add w-full min-h-full rounded-xl"><i class="fa fa-plus-circle"></i>${self._labels.ADD}</a></div>`
                        );
                },

                start(event, portlet) {
                    self._draggedFromExplorer = false;

                    portlet.helper.css({ position: 'fixed' });

                    let rowNumber = portlet.item.index();
                    let colNumber = portlet.item.closest('.portlet-block').data('number');

                    portlet.item.attr('data-prev-row', rowNumber);
                    portlet.item.attr('data-prev-col', colNumber);
                },
                update: (event, portlet) => {
                    let screenId = parseInt(portlet.item.attr('screenId'));
                    let guid = portlet.item.attr('guid');
                    let rowPositon = portlet.item.index();
                    let colPositon = portlet.item.closest('.portlet-block').data('number');

                    let position: IPosition = {
                        RowNumber: rowPositon,
                        ColNumber: colPositon,
                    };

                    if (self._draggedFromExplorer) {
                        portlet.item.remove();
                        self.AddNewPortlet(guid, screenId, position);
                    } else {
                        let prevRowPosition = portlet.item.data('prevRow');
                        let prevColPosition = portlet.item.data('prevCol');

                        let prevPosition: IPosition = {
                            RowNumber: prevRowPosition,
                            ColNumber: prevColPosition,
                        };

                        self.ChangePortletPosition(guid, prevPosition, position);
                    }
                },
            })
            .disableSelection();
    }

    GetPositions(): GuidToPortletInfoMap {
        let guidToPosition = new GuidToPortletInfoMap();

        this._attachedPortlets.toArray().forEach((portletScope) => {
            let $portletScope = $(portletScope);
            let $portlets = $portletScope.find('.portlet');

            $portlets.toArray().forEach((portlet) => {
                let $portlet = $(portlet);
                let guid = $portlet.attr('guid');

                let position: IPosition = {
                    RowNumber: $portlet.index(),
                    ColNumber: $portlet.closest('.portlet-attached').data('number'),
                };

                let state = $portlet.attr('state');

                let portletInfo: IPortletInfo = {
                    Position: position,
                    State: PortletStates[state],
                };

                guidToPosition.Add(guid, portletInfo);
            });
        });

        return guidToPosition;
    }

    private OnPortletExlorerLoaded() {
        if (!this._portletExplorereLoaded) {
            this.InitDesignMode();
        }
        this._portletExplorereLoaded = true;
    }

    private BindEvents() {
        this._portletExplorer().On(EVENTS.PORTLETS.EXPLORER_LOADED, this, () =>
            this.OnPortletExlorerLoaded()
        );
    }

    private AddNewPortlet(guid: Guid, screenId: number, position: IPosition) {
        let portlet = new EntityPortlet();
        portlet.Guid = guid;
        portlet.ScreenId = screenId;
        portlet.Position = position;

        this.Trigger(EVENTS.PORTLETS.NEW_PORTLET_ADDED, portlet);
    }

    private ChangePortletPosition(guid: Guid, prevPosition: IPosition, newPosition: IPosition) {
        let droppedObject: IDraggable = {
            Guid: guid,
            PrevPosition: prevPosition,
            NewPosition: newPosition,
        };

        this.Trigger(EVENTS.PORTLETS.PORTLET_POSITION_CHANGED, droppedObject);
    }
}
